import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { KnowledgePanelService, KnowledgePanelView } from '../../services/knowledge-service/knowledge-panel.service';
import { KnowledgeService } from '../../services/knowledge-service/knowledge.service';
import { HelpEntry } from '../../models/knowledge.model';
import { filterHelpEntries } from '../../utils/knowledge-search';

@Component({
  selector: 'app-help-sidenav',
  templateUrl: './help-sidenav.component.html',
  styleUrls: ['./help-sidenav.component.scss']
})
export class HelpSidenavComponent implements OnInit, OnDestroy {
  entry: HelpEntry | null = null;
  loading = false;
  canGoBack = false;
  view: KnowledgePanelView = 'entry';

  /** DOCU-914: topics of this application, for the list and the search. */
  overviewEntries: HelpEntry[] = [];
  searchTerm = '';

  private titles = new Map<string, string>();
  private sub?: Subscription;
  private entriesSub?: Subscription;

  constructor(
    private panelService: KnowledgePanelService,
    private knowledgeService: KnowledgeService
  ) {}

  ngOnInit(): void {
    this.entriesSub = this.knowledgeService.getAllEntriesCached().subscribe(entries => {
      // Titel aller Eintraege, auch der app-eigenen - sie koennen als verwandtes
      // Thema verlinkt sein, auch wenn sie nicht in der Liste stehen.
      this.titles = new Map(entries.map(e => [e.id, e.title]));
      this.overviewEntries = entries.filter(e => e.area?.includes('backoffice'));
    });

    this.sub = this.panelService.panelState$.pipe(
      tap(state => {
        this.canGoBack = !!state.canGoBack;
        this.view = state.view ?? 'entry';
        if (state.isOpen && this.view === 'entry') {
          this.loading = true;
          this.entry = null;
        }
      }),
      switchMap(state => {
        if (!state.isOpen || state.view === 'overview') return [];
        if (state.contextKey) {
          return this.knowledgeService.getEntryByContextKey(state.contextKey);
        }
        if (state.helpId) {
          return this.knowledgeService.getEntry(state.helpId);
        }
        return [];
      })
    ).subscribe(result => {
      this.entry = result;
      this.loading = false;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.entriesSub?.unsubscribe();
  }

  get filteredEntries(): HelpEntry[] {
    return filterHelpEntries(this.overviewEntries, this.searchTerm);
  }

  /** Falls die Liste noch nicht geladen ist, bleibt die Id als Beschriftung. */
  titleOf(id: string): string {
    return this.titles.get(id) ?? id;
  }

  close(): void {
    this.panelService.close();
  }

  openRelated(id: string): void {
    this.panelService.openById(id);
  }

  openOverview(): void {
    this.panelService.openOverview();
  }

  back(): void {
    this.panelService.back();
  }
}
